import { render, staticRenderFns } from "./PageWechatGuideIdList.vue?vue&type=template&id=59295038&scoped=true"
import script from "./PageWechatGuideIdList.vue?vue&type=script&lang=js"
export * from "./PageWechatGuideIdList.vue?vue&type=script&lang=js"
import style0 from "./PageWechatGuideIdList.vue?vue&type=style&index=0&id=59295038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59295038",
  null
  
)

export default component.exports